import React from "react";
import {
    List,
    Datagrid,
    Edit,
    Create,
    TextField,
    EditButton,
    TextInput,
    Filter,
} from "react-admin";
import BaseForm from "../baseForm";
import {BooleanField} from "admin-on-rest/lib/mui/field/BooleanField";

const form = <BaseForm fields={
    {name: '', name_vi: '', order: 0, duration: 0}
} selections={
    {inner_sound_id: 'inner-sound-all'}
} checkboxes={
    {is_introduce: false}
} files={
    {audio_file: '', audio_file_vi: ''}
}/>

const SoundFilter = (props) => (
    <Filter {...props}>
        <TextInput source="name" label="name" alwaysOn/>
    </Filter>
);

export const SoundList = props => (
    <List {...props} filters={<SoundFilter/>} filter={{is_published: true}}>
        <Datagrid>
            <TextField source="id"/>
            <TextField source="name"/>
            <TextField source="name_vi"/>
            <TextField source="order"/>
            <BooleanField source="is_introduce"/>
            <TextField source="inner_sound_name"/>
            <EditButton basePath="/sound"/>
        </Datagrid>
    </List>
);

export const SoundEdit = props => (
    <Edit title='Update' {...props}>
        {form}
    </Edit>
);

export const SoundCreate = props => (
    <Create title="Create" {...props}>
        {form}
    </Create>
);
